// Permission Types

export const AdminPermissionTypes = {
  integration: 'integration',
  account: 'account',
  billing: 'billing',
  helpdeskSupport: 'helpdeskSupport',
  configuration: 'configuration',
  importExport: 'importExport',
  systemAdministrator: 'systemAdministrator'
}

export const AutomationPermissionTypes = {
  automation: 'automation'
}

export const ContactPermissionTypes = {
  contact: 'contact',
  customerCredit: 'customerCredit',
  customerPricing: 'customerPricing',
  supplierCredit: 'supplierCredit',
  supplierPricing: 'supplierPricing',
}

export const CorePermissionTypes = {
  systemCore: 'systemCore',
  label: 'label',
}

export const CommunicationPermissionTypes = {
  comment: 'comment',
  resendCommunication: 'resendCommunication'
}

export const InventoryPermissionTypes = {
  inventoryCore: 'inventoryCore',
  stock: 'stock',
  stockTransaction: 'stockTransaction',
  stockManagement: 'stockManagement',
  stockTake: 'stockTake',
  stockTakeCount: 'stockTakeCount',
  stockTakeApproval: 'stockTakeApproval',
  stockPricing: 'stockPricing',
  inventoryConfig: 'inventoryConfig'
}

export const IntelligencePermissionTypes = {
  intelligenceInventory: 'intelligenceInventory',
  intelligenceOrder: 'intelligenceOrder',
  intelligenceProduction: 'intelligenceProduction',
  intelligenceAccount: 'intelligenceAccount',
  intelligenceSalesPricing: 'intelligenceSalesPricing',
  intelligenceDIFOT: 'intelligenceDIFOT'
}

export const PricingPermissionTypes = {
  pricingCore: 'pricingCore',
  pricingApproval: 'pricingApproval',
  pricingConfig: 'pricingConfig',
  priceListConfig: 'priceListConfig'
}

export const PurchasingPermissionTypes = {
  purchaseOrder: 'purchaseOrder',
  purchaseOrderBulk: 'purchaseOrderBulk',
  purchaseOrderStandard: 'purchaseOrderStandard',
  purchaseOrderExternal: 'purchaseOrderExternal',
  purchaseOrderApproval: 'purchaseOrderApproval'
}
export const OrderPermissionTypes = {
  order: 'order',
  orderProductionApproval: 'orderProductionApproval',
  orderPricingApproval: 'orderPricingApproval',
  orderAccountsApproval: 'orderAccountsApproval',
  orderCancel: 'orderCancel',
  orderEdit: 'orderEdit',
  orderItemEdit: 'orderItemEdit',
  orderItemCancel: 'orderItemCancel',
  orderProductionEditing: 'orderProductionEditing',
  orderAdministrator: 'orderAdministrator',
  orderConfiguration: 'orderConfiguration'
}

export const OrderEditorPermissionTypes = {
  orderEditor: 'orderEditor',
  orderEditorLibrary: 'orderEditorLibrary',
  orderEditorConfiguration: 'orderEditorConfiguration'
}

export const ProductionPermissionTypes = {
  production: 'production',
  productionStationApp: 'productionStationApp',
  productionConfig: 'productionConfig',
  productionFinance: 'productionFinance',
  productionAdministrator: 'productionAdministrator',
  productionManager: 'productionManager',
}

export const OptimiserPermissionTypes = {
  optimisation: 'optimisation',
  optimisationConfig: 'optimisationConfig',
}

export const TaskPermissionTypes = {
  task: 'task',
  taskCancel: 'taskCancel',
  taskApp: 'taskApp',
  taskManager: 'taskManager',
  taskAccountsApproval: 'taskAccountsApproval',
  taskConfig: 'taskConfig',
}

export const AccountsPermissionTypes = {
  invoice: 'invoice',
  creditNote: 'creditNote',
  payment: 'payment',
  orderEntryPayment: 'orderEntryPayment',
  accountReports: 'accountReports',
  accountConfig: 'accountConfig',
  accountAdministrator: 'accountAdministrator'
}

export const UserPermissionTypes = {
  user: 'user',
  userGroup: 'userGroup',
  permission: 'permission'
}

export const AIPermissionTypes = {
  aiChat: 'aiChat',
  aiConfig: 'aiConfig'
}